import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const businessApi = createApi({
  reducerPath: "businessApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Business/`),

  endpoints: (builder) => ({
    getBusiness: builder.query({
      query: () => ({
        url: "GetBusiness",
        method: "GET",
      }),
    }),

    updateBusiness: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateBusiness",
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const { useGetBusinessQuery, useUpdateBusinessMutation } = businessApi;

export default businessApi.reducer;
